import React from 'react';
import { useLocation } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import WebsiteInterviewPage from '../../features/website-interview/components/WebsiteInterviewPage';

const InterviewPageRoute = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const explicitToolType = params.get('toolType');
  const toolType = explicitToolType || 'interview_simulator';

  const role = params.get('role') || '';
  const title = params.get('title') || undefined;

  const appContext = toolType
    ? {
        title: title || 'Interview Simulator',
        exam_name: toolType,
      }
    : undefined;

  return (
    <ProtectedRoute requiresAuth={true}>
      <WebsiteInterviewPage
        appContext={appContext}
        initialRole={role}
        toolType={toolType}
      />
    </ProtectedRoute>
  );
};

export default InterviewPageRoute;